var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __spreadArrays =
  (this && this.__spreadArrays) ||
  function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j]
    return r
  }
import { selectKeyPath } from '@odc/odbelt'
import { useFormikContext } from 'formik'
import React from 'react'
import styled from 'styled-components'
import { useDetectOutsideClick } from '../../../../../hooks'
import { useODEntityContext } from '../../../context/useODEntityContext'
import { DragAndDropComponent } from './DragAndDropComponent'
var Wrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n'],
      ['\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n']
    ))
)
export function ODMultipleFileInput(props) {
  var _a
  var formikContext = useFormikContext()
  var entityContext = useODEntityContext()
  var _b = React.useState(false),
    isUploadViewOpen = _b[0],
    setIsUploadViewOpen = _b[1]
  var dndRef = React.useRef(null)
  useDetectOutsideClick(
    function () {
      return setIsUploadViewOpen(false)
    },
    dndRef,
    isUploadViewOpen
  )
  var width = props.width,
    height = props.height,
    name = props.name,
    keyPath = props.keyPath,
    renderDropzoneChild = props.renderDropzoneChild,
    _c = props.style,
    style =
      _c === void 0
        ? function () {
            return {}
          }
        : _c,
    render = props.render,
    _d = props.validate,
    validate =
      _d === void 0
        ? function () {
            return true
          }
        : _d,
    accept = props.accept,
    _e = props.insertFront,
    insertFront = _e === void 0 ? false : _e
  var _f = formikContext || {},
    setFieldValue = _f.setFieldValue,
    _g = _f.values,
    values = _g === void 0 ? {} : _g
  // @ts-ignore
  var v = values
  var fieldRendered = render(v, {
    formikContext: formikContext,
    entityContext: entityContext,
    removeItem: function (index) {
      var _a
      var existingValues = selectKeyPath(keyPath)(values, null)
      if (existingValues === null) {
        // tslint:disable-next-line:no-console
        console.warn('ODMultipleFileInput failed to select existing values during removeItem()')
        return
      }
      var newValues = __spreadArrays(existingValues)
      newValues.splice(index, 1)
      ;(_a = setFieldValue) === null || _a === void 0 ? void 0 : _a(name, newValues)
    },
  })
  var handleChange = React.useCallback(
    function (files, bUrls, value) {
      if (validate) {
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
          var file = files_1[_i]
          if (!validate(file)) {
            return
          }
        }
      }
      var localFiles = files.map(function (file, index) {
        var localFile = file
        localFile.blobUrl = bUrls[index]
        return localFile
      })
      var existingValues = selectKeyPath(keyPath)(value, null)
      if (existingValues === null) {
        // tslint:disable-next-line:no-console
        console.warn('ODMultipleFileInput selecting key path ' + keyPath + ' failed.')
        return
      }
      if (insertFront) {
        setFieldValue(name, __spreadArrays(localFiles, existingValues))
      } else {
        setFieldValue(name, __spreadArrays(existingValues, localFiles))
      }
    },
    [name, setFieldValue, insertFront]
  )
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      Wrapper,
      {
        style: __assign({ width: width, height: height, border: isUploadViewOpen ? '0' : undefined }, style(v)),
        ref: dndRef,
        onDragEnter: function () {
          return setIsUploadViewOpen(true)
        },
        onClick: function () {
          return setIsUploadViewOpen(true)
        },
      },
      React.createElement(DragAndDropComponent, {
        multiple: true,
        accept: accept,
        style: { width: width, height: height },
        isOpen: isUploadViewOpen,
        onChangeFiles: function (files, bUrls) {
          return handleChange(files, bUrls, v)
        },
        onClose: function () {
          return setIsUploadViewOpen(false)
        },
        onDragLeave: function () {
          return setIsUploadViewOpen(false)
        },
        toggle: function () {
          return setIsUploadViewOpen(function (value) {
            return !value
          })
        },
      }),
      (_a = renderDropzoneChild) === null || _a === void 0 ? void 0 : _a()
    ),
    fieldRendered
  )
}
var templateObject_1
//# sourceMappingURL=ODMultipleFileInput.js.map
